module.exports = __webpack_public_path__ + "img/fig13.f7926c79.jpg";